import styled from "styled-components";
import { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const Container = styled.div`
	width: 100%;
`;

interface IMainParts {
	layoutGrid: boolean;
}

// Styles to Main
export const Main = styled.div<IMainParts>`
	${(props) =>
		props.layoutGrid
			? `
    display: grid;
    align-items: start;
    grid-template-columns: repeat(auto-fill, 200px);
    justify-content: space-between;
    grid-gap: 0.4rem;
    margin-bottom: 0.4rem

    @media (max-width: 768px) {
      justify-items: center;
      justify-content: space-around;
    }
  `
			: {
					display: "flex",
					flexWrap: "wrap",
					flexDirection: "column",
					gridGap: "0",
					overflow: "auto",
				}};

	> .box-layout-card-collumn {
		display: flex;

		width: 100%;
		align-items: stretch;
		border-radius: 0px;
		box-shadow: none;
		padding: 0.8rem 0rem;
		border: 1px solid ${({ theme }) => theme.pantone642C};
		&:not(:nth-child(2)) {
			border-top: 0px;
		}

		&.supplier-recommended {
			border: 1px solid ${({ theme }) => theme.pantone2726C};
		}
	}

	&.data-layout-column-supplier {
		.box-layout-card-collumn {
			min-width: max-content;
		}
	}
`;

export const MainParts = styled(Main)<IMainParts>`
	${(props) =>
		props.layoutGrid
			? {
					gridTemplateColumns: "repeat(auto-fill, 200px)",
				}
			: {
					display: "flex",
					flexWrap: "wrap",
					flexDirection: "column",
					gridGap: "0",
					overflow: "auto",
				}};
`;

export const HeaderMain = styled.div``;
export const ContentMain = styled.div``;
interface IHideComponent {
	isHide: boolean;
}
export const HideComponent = styled.div`
	display: ${(props: IHideComponent) => (props.isHide ? "none" : "inherit")};
`;

// Logic drawner
const drawerWidth = 300;
export const isMobile = window.innerWidth <= 768;
export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			position: "relative",
			display: "flex",
			flexDirection: "column",
		},
		appBar: {
			backgroundColor: "#fff",
			top: "58px",
			background: "none",
			boxShadow: "none",
			color: "inherit",
			zIndex: 49,
			transition: theme.transitions.create(["margin", "width"], {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
		},
		toolBar: {},
		toolbarShift: {
			width: `calc(100 % - ${drawerWidth}px)`,
			transition: theme.transitions.create(["margin", "width"], {
				easing: theme.transitions.easing.easeOut,
				duration: theme.transitions.duration.enteringScreen,
			}),
			marginLeft: isMobile ? 0 : drawerWidth,
		},
		title: {
			flexGrow: 1,
		},
		hide: {
			display: "none",
		},
		drawer: {
			width: drawerWidth,
			flexShrink: 0,
		},
		drawerPaper: {
			position: "absolute",
			width: drawerWidth,
			height: "calc(100vh - 60px)",
			padding: "0 0 140px 0",
		},
		content: {
			flexDirection: "column",
			flexGrow: 1,
			padding: theme.spacing(3),
			paddingTop: theme.spacing(1),
			transition: theme.transitions.create("margin", {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
			marginLeft: 0,
		},
		contentShift: {
			transition: theme.transitions.create("margin", {
				easing: theme.transitions.easing.easeOut,
				duration: theme.transitions.duration.enteringScreen,
			}),
			marginLeft: isMobile ? 0 : drawerWidth,
		},
	}),
);
// Screenparts
const widthPartName = "250px"; //This column is dinamic
const widthCategory = "320px";
const widthSubCategory = "240px";
const widthPosition = "240px";

// ScreenSupplierparts
const widthImage = "100px";
const widthSupplier = "280px";
const widthSku = "140px";
const widthPartyType = "100px";
const widthProduct = "400px"; // This column is dinamic
const widthRating = "200px";
const widthPrice = "100px";
const widthDeliveryTime = "100px";

// ScreenSupplierParts/ScreenParts
const widthAddToCart = "200px";

const minWidthAwaitingAnswer = [
	widthSku,
	widthPartyType,
	widthProduct,
	widthDeliveryTime,
	widthRating,
	widthPrice,
	widthAddToCart,
].reduce((acc, cur) => acc + Number(cur.replace("px", "")), 0);

export const MainContent = styled.main`
	word-break: break-word;
	.products-list__column.products-list__column--image {
		display: flex;
		justify-content: center;
		align-items: center;
		width: ${widthImage};
		flex-shrink: 0;

		> img {
			width: 100%;
			max-width: 90px;
			max-height: 90px;
			min-width: 90px;
			min-height: 90px;
			object-fit: contain;
		}
	}
	.products-list__column.products-list__column--supplier {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-around;
		min-width: ${widthSupplier};
		max-width: ${widthSupplier};
		gap: 15px;

		> span {
			width: 100%;
			max-width: 100%;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}
	}
	.products-list__column.products-list__column--sku {
		display: flex;
		justify-content: center;
		width: 100%;
		max-width: ${widthSku};
		min-width: ${widthSku};
	}
	.products-list__column.products-list__column--partyType {
		display: flex;
		justify-content: start;
		width: 100%;
		max-width: ${widthPartyType};
		min-width: ${widthPartyType};
	}
	.products-list__column.products-list__column--product {
		width: 100%;
		min-width: ${widthProduct};
	}
	.products-list__column.products-list__column--partName {
		display: flex;
		min-width: ${widthPartName};
		max-width: ${widthPartName};
		width: 100%;
	}
	.products-list__column.products-list__column--category {
		width: 100%;
		min-width: ${widthCategory};
		display: flex;
		flex-grow: 1;
	}
	.products-list__column.products-list__column--subCategory {
		display: flex;
		min-width: ${widthSubCategory};
		max-width: ${widthSubCategory};
	}
	.products-list__column.products-list__column--position {
		display: flex;
		min-width: ${widthPosition};
		max-width: ${widthPosition};
	}
	.products-list__column.products-list__column--rating {
		width: 100%;
		max-width: ${widthRating};
		min-width: ${widthRating};
		justify-content: center;
		margin-left: 1px;
	}
	.products-list__column.products-list__column--price {
		display: flex;
		flex-direction: column;
		justify-content: center;
		width: 100%;
		max-width: ${widthPrice};
		min-width: ${widthPrice};
		margin: 0 1px;
		white-space: nowrap;
	}
	.products-list__column.products-list__column--addToCart {
		display: flex;
		width: 100%;
		max-width: ${widthAddToCart};
		min-width: ${widthAddToCart};
		margin: 0 1px;
		justify-content: center;

		> button {
			margin: 0;
		}
	}

	.products-list__column.products-list__column--deliveryTime {
		width: 100%;
		max-width: ${widthDeliveryTime};
		min-width: ${widthDeliveryTime};
	}

	.products-list__column.products-list__column--awaitingAnswer {
		display: flex;
		align-items: center;
		justify-content: center;
		min-width: calc(${`${minWidthAwaitingAnswer}px`} + 3px);
		width: 100%;
		margin: 0 1px;

		> span {
			margin: 0;
		}
	}

	.products-list__column {
		font-size: 13px;
		font-weight: 700;
		align-items: center;
		display: flex;
		padding: 0 16px;
	}
`;
export const BoxProductLayout = styled.div``;
